/**
 * TanStack Query hooks for `agency-plan-unlock-multi-client-sub-admins-white-label-smartlink-manual-campaign-grouping`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	agencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingQueryKeys,
	type CreateAgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingBody,
	type ListAgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingResponse,
	type AgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingRow,
} from "./api";

export function useAgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingList(): UseQueryResult<ListAgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingResponse, Error> {
	return useQuery({
		queryKey: agencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingQueryKeys.list(),
		queryFn: list,
	});
}

export function useAgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingCreate(): UseMutationResult<AgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingRow, Error, CreateAgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: agencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingQueryKeys.all });
		},
	});
}

export function useAgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: agencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingQueryKeys.all });
		},
	});
}
